import { useEffect, useRef, useState } from 'react'
import {
  VStack,
  Wrap,
  Tag,
  TagLabel,
  TagCloseButton,
  Text,
} from '@chakra-ui/react'
import { TreeDropdown } from '@/components/forms/TreeDropdown'

interface MultiTreeDropdownProps {
  value?: number[]
  onChange?: (value: number[]) => void
  loadOptions?: any
  placeholder?: string
  valueLabels?: Record<number, string>
}

export function MultiTreeDropdown({
  value = [],
  onChange,
  loadOptions,
  placeholder,
  valueLabels = {},
}: MultiTreeDropdownProps) {
  const treeRef = useRef<any>(null)
  const [options, setOptions] = useState<any[]>([])

  // Load tree options
  useEffect(() => {
    loadOptions?.(null, (data: any[]) => {
      setOptions(Array.isArray(data) ? data : [])
    })
  }, [loadOptions])

  // Resolve label from tree
  const resolveName = (id: number, items: any[]): string => {
    for (const item of items) {
      if (String(item.id) === String(id)) return item.label || item.name
      if (item.children) {
        const found = resolveName(id, item.children)
        if (found) return found
      }
    }
    return valueLabels[id] || 'Unknown category'
  }

  // Add item from TreeDropdown
  const handleSelect = (val: string) => {
    try {
      const parsed = JSON.parse(val)
      if (!parsed?.id) return

      const current = value ?? []

      if (current.includes(parsed.id)) return

      const updated = [...current, parsed.id]

      onChange?.(updated)

      treeRef.current?.clearSearch?.()
    } catch {}
  }

  // Remove tag
  const handleRemove = (id: number) => {
    const updated = (value ?? []).filter((v) => v !== id)
    onChange?.(updated)
  }

  return (
    <VStack align="stretch" spacing={2}>
      <TreeDropdown
        loadOptions={loadOptions}
        placeholder={placeholder}
        onChange={handleSelect}
      />

      {/* TAG UI */}
      <Wrap>
        {value.map((id) => (
          <Tag key={id} colorScheme="blue" borderRadius="full">
            <TagLabel>{resolveName(id, options)}</TagLabel>
            <TagCloseButton onClick={() => handleRemove(id)} />
          </Tag>
        ))}
      </Wrap>

      {/* optional debug */}
      {value.length === 0 && (
        <Text fontSize="sm" color="gray.500">
          No categories selected
        </Text>
      )}
    </VStack>
  )
}